<template>
	<div class="bg">
		<div class="joinus">
			<div class="titile">
				<h1>加盟方帝斯酒保 </h1>
				<span class="title_style_box title_style"></span><span class="title_style_box title_style_2"></span>
			</div>
			
			<div class="graph">
				<div class="joinus_box">
					<div class="joinus_top">
						<input type="text" class="input_text input_text_right_bottom" v-model="name" placeholder="您的姓名" /><input type="text" class="input_text" v-model="tel" placeholder="您的联系方式"/>
						<div class="joinus_top_bottom"></div>
					</div>
					<div class="joinus_middle">
						<textarea name="" rows="" cols="" placeholder="您的信息（200字以内）" maxlength="200" v-model="infor"></textarea>
					</div>
					<div class="joinus_bottom" v-on:click="submit">提交</div>
				</div>
				<div class="mountings"></div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
    name: 'joinus',
    data () {
	    return {
	        name: '',
	        tel: '',
	        infor: ''
	    }
	},
    components: {
	},
	methods: {
		submit(){
			let name = this.name,
			tel = this.tel,
			infor = this.infor
			console.log("name=="+name)
			console.log("tel=="+tel)
			console.log("infor=="+infor)
		}
   
	}
}
</script>

<style>
	.bg{
		-webkit-font-smoothing: antialiased;/*使低像素图标字体更清晰*/
	    -moz-osx-font-smoothing: grayscale;
	    background-image: url('../../assets/images/mountings.png'); /*背景图片地址*/
		background-repeat: no-repeat;/*背景图片不重复*/
		background-size: cover;/*背景图片拉伸铺满*/
		width: 100%; 
		z-index: 2;
		padding-top: 80px;
		box-sizing: border-box;
	}
	.joinus{
		width: 790px;
		height: 340px;
		margin: 0 auto;
		box-sizing: border-box;
		overflow: hidden;
	}
	.titile{
		padding: 10px 0;
	}
    .titile h1{
    	color: #fff;
    	display: inline-block;
    	vertical-align: middle;
    }
    .title_style_box{
    	display: inline-block;
    	height: 31px;
    	background: #c4a174;
    	vertical-align: middle;
    }
    .title_style{
    	width: 8px;
    	margin-right: 6px;
    }
    .title_style_2{
    	width: 24px;
    }
    .graph{
    	overflow: hidden;
    	position: relative;
    }
    /*等腰梯形*/
    .graph:before{
    	border-color: #fff transparent transparent ;
    	border-style: solid solid none;
    	border-width: 800px 100px 0;
    	content:"";
    	display:block;
    	height:0;
    	width:100%;
    	box-sizing: border-box;
    }
    .joinus_box{
    	position: absolute;
    	top: 0;
    	width: 100%;
    }
    /*上部input样式*/
    .joinus_top{
    	/*border-bottom: 3px solid #3d3c37;*/
    	display: flex;
    	justify-content: space-around;
    	position: relative;
    }
    .joinus_top_bottom:after {
        content: '';
        position: absolute;
        left: 5px;
        top: auto;
        bottom: 0;
        right: auto;
        height: 3px;
        width: 95%;
        background-color: #3d3c37;
    }
    .joinus_top>.input_text{
    	display: inline-block;
    	background: #fff;
    	border: 0;
    	width: 46%;
    	height: 35px;
    }
    .joinus_top>.input_text_right_bottom{
    	border-right: 3px solid #3D3C37;
    }
    /*中部textarea样式*/
    .joinus_middle{
    	width: 100%;
    	box-sizing: border-box;
    	display: flex;
    	justify-content: space-around;
    }
    .joinus_middle>textarea{
    	border: none;
    	width: 722px;
    	height: 200px;
    	border-bottom: 3px solid #3D3C37;
    	padding: 30px;
    	box-sizing: border-box;
    	font-size: large;
    }
    .joinus_bottom{
    	text-align: center;
    	font-size: large;
    	padding: 10px;
    }
    .mountings{
    	transform:skewX(-7deg);
		-ms-transform: skewX(-7deg);
		-moz-transform: skewX(-7deg);
		-webkit-transform: skewX(-7deg);
		-o-transform: skewX(-7deg);
    	background: #c4a174;
    	width: 40px;
    	height: 300px;
    	position: absolute;
    	top: 0;
    	right: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/joinus/joinus.vue